import { Component, forwardRef, OnInit, ViewChild, AfterViewInit, ComponentRef } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { IComponentDef } from '../../../shared';
import { DWidgetFormRenderComponent } from '../../common-component/d-widget-form-render/d-widget-form-render.component';

@Component({
  selector: 'app-d-groups',
  templateUrl: './d-groups.component.html',
  styles: [
    `
      .d-groups {
        min-height: 100px;
        background: #fff;
        border: 1px dashed #ccc;
        position: relative;
        z-index: 1001;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DGroupsComponent),
      multi: true
    }
  ]
})
export class DGroupsComponent extends DynamicComponentBase {
  static KEY = 'd-group';

  constructor() {
    super();
  }
  ngAfterViewInit(): void {}

  configChange(config: IDynamicComponentConfig) {
    if (!config.labelPosition) {
      config.labelPosition = 'top';
    }
  }

  selectComponentChange(value) {}
}
